import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import DataTableManagersShop from "../../ui/DataTableManagersShop";
import { Alert, Snackbar } from "@mui/material";
import UserService from "../../services/PosService/UserService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const ManagerShop = ({ startLoading, stopLoading }) => {
  const [availableManagers, setAvailableManagers] = useState([]);
  const [availableManagersToSelect, setAvailableManagersToSelect] = useState(
    []
  );
  const [shop, setShop] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  useEffect(() => {
    startLoading();
    UserService.getAllManagersByShop(
      getCurrentUserId(),
      localStorage.getItem("idMagasinManagers")
    )
      .then((response) => {
        if (response?.status == 200) {
          setAvailableManagers(response?.data?.success);
        } else if (response?.data?.error) {
          setErrorAlertText("error " + response?.data?.error);
        }
      })
      .catch((error) => {
        setErrorAlertText("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  useEffect(() => {
    startLoading();
    UserService.getAllManagersToSelect(getCurrentUserId())
      .then((response) => {
        if (response?.status == 200) {
          setAvailableManagersToSelect(response?.data?.success);
        } else if (response?.data?.error) {
          setErrorAlertText("error " + response?.data?.error);
        }
      })
      .catch((error) => {
        setErrorAlertText("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const filterManagerShop = () => {
    return (
      <>
        <DataTableManagersShop
          managersShop={availableManagers}
          availableManagersToSelect={availableManagersToSelect}
          setAvailableManagersToSelect={setAvailableManagersToSelect}
        />
      </>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                Les directeurs de magasin : {""}
                {""}
                {""}
                {/* <b>{shop}</b> */}
              </h5>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterManagerShop()}</div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ManagerShop);
